const removeMatchingOffers = <T>(offer: T) => ({
  ...offer,
  matchingOffer: undefined,
});

export default removeMatchingOffers;
